/* eslint-disable react/jsx-filename-extension */

import React from 'react';

import { WrapPageElement, WrapRootElement } from './src/components/wrapElement';

import './src/utils/sentry';
import './src/utils/posthog';

// required for react-fetching-library (https://github.com/marcin-piela/react-fetching-library/issues/37#issuecomment-578544933)
const { Buffer } = require('buffer/');

window.Buffer = Buffer;

/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

export const wrapPageElement = ({ element }) => <WrapPageElement>{element}</WrapPageElement>;

export const wrapRootElement = ({ element }) => <WrapRootElement>{element}</WrapRootElement>;
